import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  bottomRow: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  container: {
    flexDirection: 'column',
    height: Theme.px(120),
    width: Theme.px(1420),
  },
  topRow: {
    alignItems: 'center',
    flexDirection: 'row',
    height: Theme.px(77),
    justifyContent: 'flex-start',
    marginBottom: Theme.px(8),
    width: '100%',
  },
});
